// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React, {useState} from "react";
import { observer } from "mobx-react";

import "./home.css";

export const HomePage = observer(() => {
  const [isLoadedVideo, setLoadedVideo] =useState(false);

  return (
    <>
      <div className="main" id="index">
        <div className="main-content">
          <div className="home-wrapper">
            <div className="home-mask" style={{display: isLoadedVideo ? 'block' : 'none'}}>
              <video autoPlay={true} loop muted onLoadedData={()=>setLoadedVideo(true)}>
                <source
                  src="/custom-content/42Q-SOMS-Airport-Scene-For-Web.mp4"
                  type="video/mp4"
                />
              </video>
              <div className="sub-mask"></div>
            </div>
            <div className="row home-page-jumbotron-bg" id="top-promo">
              <div className="row-container wrap-overflow">
                <ul className="events-tracker events-tracker_col-view events-tracker_col-blue">
                  <li className="events-tracker__item">
                    <div className="events-tracker__title">Cloud Solution:</div>
                    <div className="events-tracker__counter">1</div>
                  </li>
                  <li className="events-tracker__item">
                    <div className="events-tracker__title">Countries:</div>
                    <div className="events-tracker__counter">60+</div>
                  </li>
                  <li className="events-tracker__item">
                    <div className="events-tracker__title">Production Lines:</div>
                    <div className="events-tracker__counter">470+</div>
                  </li>
                  <li className="events-tracker__item">
                    <div className="events-tracker__title">
                      Top Level Assemblies:
                    </div>
                    <div className="events-tracker__counter">120,000</div>
                  </li>
                </ul>
                <div className="col-xs-12 white normal-float">
                  <h1 id="homepage-title">
                    WELCOME TO <br />
                    THE 42Q <br />
                    DEVELOPER <br />
                    NETWORK <br />
                  </h1>
                </div>
                <div className="col-xs-12 col-sm-11 col-md-10">
                  <p>
                    Join the 42Q developer network, build innovative applications
                    to bring connection between your manufacturing production and
                    42Q.
                  </p>
                </div>
                <div className="col-xs-12 button-block">
                  <a className="tm-btn tm-btn-white rightarrow" href="/dashboard">
                    GET YOUR API KEY
                  </a>
                  <a
                    className="tm-btn tm-btn-transparent rightarrow"
                    href="/getting-started"
                  >
                    3 MINUTE QUICK START GUIDE
                  </a>
                  <a className="tm-btn tm-btn-transparent" href="/apis">
                    EXPLORE THE APIs
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
});

export default HomePage;
